import addAdditionalInfoToProseMirrorNode from "@/view/ProseMirrorNode/addAdditionalInfoToProseMirrorNode";
import sanitizeAnnotations from "@/view/ProseMirrorNode/addAdditionalInfoToProseMirrorNode/utils/sanitizeAnnotations";
import orderAnnotationsWithinTextNodes from "../orderAnnotationsWithinTextNodes";
import sanitizeRawText from "../sanitizeRawText";

// Depends on the article level for the raw text.
const getArticleAndAnnotationsData = ({
  annotations,
  rawText,
  removePowerWords = false,
}) => {
  if (!rawText) return {};

  const sanitizedRawText = sanitizeRawText(rawText, removePowerWords);
  const sanitizedAnnotations = sanitizeAnnotations(
    annotations,
    sanitizedRawText,
  );

  const { orderedListOfAnnotations, ...remainingAnnotationContentData } =
    addAdditionalInfoToProseMirrorNode({
      data: sanitizedRawText,
      annotations: sanitizedAnnotations,
    });
  // The ordered list of annotations returned from addAdditionalInfoToProseMirrorNode will not include sorting annotations starting within the same text node,
  // so an additional sorting step is needed.
  const orderedListOfAnnotationsWithinTextNodes =
    orderAnnotationsWithinTextNodes(orderedListOfAnnotations);

  return {
    ...remainingAnnotationContentData,
    orderedListOfAnnotations: orderedListOfAnnotationsWithinTextNodes,
  };
};

export default getArticleAndAnnotationsData;
